<template>
  <div>
    <b-modal id="deleteJobModal" title="Confirm Deletion" centered>
      <template v-slot:modal-header>
        <div class="w-100">
          <h5 class="modal-heading mb-0">Confirm Deletion</h5>
        </div>
      </template>

      <div class="my-4">
        <p class="text-muted fs-14 mt-2 mb-0">Are you sure you want to delete? This action cannot be undone.</p>
      </div>

      <template v-slot:modal-footer class="footer">
        <div class="w-100 d-flex justify-content-end gap-2">
          <button class="btn button-dark cancel-btn fw-normal" @click="close">
            Cancel
          </button>
          <button class="btn btn-danger fw-normal" @click="confirm">
            Delete
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { MODAL_NAMES } from '../../utils/constants';

const { DELETE_JOB_MODAL } = MODAL_NAMES;

export default {
  name: "modalDeleteJob",
  data() {
    return {
      jobToDelete: null
    };
  },
  methods: {
    open(job) {
      this.jobToDelete = job;
      this.$bvModal.show(DELETE_JOB_MODAL);
    },
    close() {
      this.jobToDelete = null;
      this.$bvModal.hide(DELETE_JOB_MODAL);
    },
    confirm() {
      this.$emit("confirmed", this.jobToDelete);
      this.close();
    }
  }
};
</script>

<style scoped>
.modal-heading {
  color: #3A3A3A;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 27px;
}

.text-muted {
  color: #6c757d !important;
}

.cancel-btn {
  background-color: #EEF2F5 !important;
}

.gap-2>*+* {
  margin-left: 0.5rem !important;
}

::v-deep .modal-footer {
  background: #FFFFFF !important;
  border-top: 1px solid #EBEBED !important;
}

::v-deep #deleteJobModal {
  overflow: hidden !important;
}

::v-deep .modal-header {
  border-bottom: 1px solid #EBEBED !important;
}
</style>
